__turbopack_context__.v({
  "fadeIn": "AuthInfo-module-scss-module__2kfJda__fadeIn",
  "loader": "AuthInfo-module-scss-module__2kfJda__loader",
  "overlay": "AuthInfo-module-scss-module__2kfJda__overlay",
  "spin": "AuthInfo-module-scss-module__2kfJda__spin",
});
